<div
  class="w-full"
  [class]="
    withBorder() && useSteps()
      ? 'border border-gray-400 dark:border-gray-700 rounded-lg'
      : ''
  "
>
  <!-- Título do formulário -->
  <ui-label *ngIf="formName()" [tag]="ELabeltype.TITLE" [type]="EAlert.INFO">{{
    formName()
  }}</ui-label>
  <br *ngIf="formName()" />

  <!-- Barra de progresso -->
  <ui-step-progress
    *ngIf="useSteps()"
    [steps]="form()"
    [currentStep]="currentStage()"
    (stepChange)="onTab($event)"
  >
  </ui-step-progress>
  <br *ngIf="useSteps()" />

  <!-- Formulário -->
  <form
    (keydown)="onKeyDown($event)"
    [ngClass]="
      !inList() && useSteps()
        ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center'
        : 'grid grid-cols-1 gap-4'
    "
  >
    <!-- Container dos campos do formulário -->
    <div #container class="hidden"></div>

    <!-- Estado de carregamento -->
    <div
      *ngIf="loading()"
      class="flex flex-col items-center justify-center w-full p-6 border-2 border-gray-300 border-dashed rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600"
    >
      <svg
        class="w-10 h-10 text-gray-500 dark:text-gray-400 animate-spin"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <circle
          cx="50"
          cy="50"
          r="35"
          stroke="currentColor"
          stroke-width="8"
          stroke-dasharray="100 50"
        ></circle>
      </svg>
      <p class="mt-4 text-sm text-gray-500 dark:text-gray-400 font-semibold">
        Estamos processando os dados do formulário...
      </p>
    </div>

    <!-- Nenhum dado disponível -->
    <div
      *ngIf="!loading() && form().length <= 0"
      class="flex flex-col items-center justify-center w-full p-6 border-2 border-gray-300 border-dashed rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600"
    >
      <p class="text-sm text-gray-500 dark:text-gray-400 font-semibold">
        Nenhum dado disponível para exibição
      </p>
      <p class="text-xs text-gray-500 dark:text-gray-400">Tente novamente!</p>
    </div>
  </form>
  @if(submitName && showButtons()){
  <!-- Botões -->
  <div class="flex flex-col gap-4 mt-3">
    <div [class]="useSteps() ? 'flex justify-between' : 'flex justify-end'">
      <ui-button
        *ngIf="useSteps() && form().length > 0"
        [type]="EAlert.DARK"
        text="Voltar"
        [size]="EComponentSize.Large"
        (action)="onBack($event)"
      ></ui-button>
      <ui-button
        [type]="EAlert.INFO"
        [text]="submitName"
        [size]="EComponentSize.Large"
        (action)="onSubmit($event)"
      ></ui-button>
    </div>
  </div>
  }
</div>